import { render } from "./LayoutCustomizer.vue?vue&type=template&id=c69351e0"
import script from "./LayoutCustomizer.vue?vue&type=script&lang=js"
export * from "./LayoutCustomizer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__